import React, { Component } from 'react';
import  './Login.css';
import { connect } from 'react-redux';
import { modificaToken, modificaNome } from '../../actions/LoginActions'
import { endpoint } from '../../helpers/constantes';
import 'bootstrap/dist/css/bootstrap.css';
class Login extends Component {

  state = {
       user: '',
       password: '',
       
  }

  constructor(props) {
      super(props);
      if (localStorage.getItem('token') !== null && localStorage.getItem('nome') !== null && localStorage.getItem('nvl') !== null) {
        
        const token = localStorage.getItem('token');
        const nome = localStorage.getItem('nome');
        this.props.modificaToken(token);
        this.props.modificaNome(nome);
        this.props.history.push('/dashboard');
        return;
     }
  }
   logaApi = async () => {
    
     const body = this.state;
     console.log('BODY', body);
     const myHeaders = new Headers();
     myHeaders.append('Content-Type', 'application/json');
    const result = await fetch(`${endpoint}/login`, {
      method: 'POST',
      headers: myHeaders,
      body: JSON.stringify(body),
    });
    
    console.log('REUSLT STATUS', result.status);
    if(result.ok) {
        const resultJson = await result.json();
        if (resultJson.nivel_acesso < 2) {
            alert('Você não tem permissão para acessar essa área administrativa');
            return;
        }
        const {token, nome, nivel_acesso} = resultJson
        this.props.modificaToken(token);
        this.props.modificaNome(nome);
        localStorage.setItem('token', token);
        localStorage.setItem('nome', nome);
        localStorage.setItem('nvl', nivel_acesso);
        this.props.history.push('/dashboard');
    } else {
        alert('Usuário ou senha errados, tente novamente');
    }
     

   }

   render(){    
    return (        
        <div className="fundo">
            <h1 className="header">Bem-Vindo(a)</h1>
            <h4 className="header">Insira seu usuário e senha</h4>
           <div className="login shadow-lg p-3 mb-5 bg-white rounded">
           <form> 
            <div className="form-group">
                <input type="text" className="form-control" value={this.state.user} 
                onChange={(evt) => this.setState({user:evt.target.value}) } id="user" placeholder="Usuário" />
            </div>
            <div className="form-group">
                <input type="password" className="form-control"  value={this.state.password}
                onChange={(evt) => this.setState({password: evt.target.value})} id="password" placeholder="Senha" />
            </div>
            <div className="form-group">
            <button type="button" className="btn btn-outline-danger btn-sm btn-block" onClick={() => this.logaApi()}>Entrar</button>

            </div>
           </form>
           </div>
        </div>
       

    );
   }
}

const mapStateToProps = state => ({
   
});

export default connect(mapStateToProps, {
    modificaToken,
    modificaNome
})(Login);


// WEBPACK FOOTER //
// ./src/components/Login/Login.js